/*
 * @Author: knight
 * @Title:  spm report日志上报
 * @Date: 2020-04-09 16:27:40
 * @Last Modified by: knight
 * @Last Modified time: 2020-04-29 11:54:59
 */
// 参考文档
// https://info.bilibili.co/pages/viewpage.action?pageId=3688605

import { report } from '../utils/report';
import { checkInView, throttle } from '../utils';
// const logger = require('debug')('app:directive:report');

const Adv2 = {

    // 等待曝光队列
    adShowWaitingQueue: new Map(),

    // 已曝光 严格上报队列
    adShowStrictQueue: new Map(),

    id: 0,

    install(Vue) {
        this.setDirective(Vue);

        this.setShowHandler();
    },

    setDirective(Vue) {
        const _this = this;

        // Vue.directive('report', {
        //     bind(el, binding) {
        //         const { value } = binding;
        //         el._handlder = () => _this.onAdClick(value.data, value.id);
        //         el.addEventListener('click', el._handlder, false);
        //     },
        //     unbind(el) {
        //         logger('解绑了');
        //         el.removeEventListener('click', el._handlder);
        //     }
        // });

        Vue.directive('reportShow', {
            bind(el, binding) {
                const { value } = binding;

                el.setAttribute('data-report-id', _this.id);

                _this.adShowWaitingQueue.set(
                    _this.id,
                    {
                        id: _this.id,
                        data: value.data,
                        eventName: value.eventName,
                        el,
                        height: el.offsetHeight
                    }
                );

                _this.id++;

            },
            // 要获取真实dom高度需要在此获取
            inserted(el) {
                const idVal = Number(el.getAttribute('data-report-id'));

                if (_this.adShowWaitingQueue.has(idVal)) {
                    const target = _this.adShowWaitingQueue.get(idVal);
                    const targetHeight = el.offsetHeight;
                    if (target.height !== targetHeight) {
                        target.height = targetHeight;
                    }
                }

            },
            unbind() {
                // logger('解绑了');
                _this.id = 0;

                _this.adShowWaitingQueue = [];
            }
        });
    },

    setShowHandler () {
        const EventNames = ['scroll', 'resize', 'load'];
        let scrollTimer;

        const _this = this;

        const scrollEnd = function (e) {
            clearTimeout(scrollTimer);
            scrollTimer = setTimeout(() => {
                _this.processAd();
            }, 201);
        };

        const tProcess = throttle(scrollEnd, 200, 100);

        if (typeof window !== 'undefined') {
            for (let j = 0; j < EventNames.length; ++j) {
                window.addEventListener(EventNames[j], tProcess, false);
            }
        }
    },

    // 曝光检测
    processAd() {
        // eslint-disable-next-line camelcase
        for (let [id, waitingItem] of this.adShowWaitingQueue) {
            if (checkInView(waitingItem.el, -waitingItem.height / 2)) {

                // console.log(waitingItem.el, waitingItem.height);
                this.onAdShow(waitingItem.data, waitingItem.eventName);

                this.adShowWaitingQueue.delete(id);

                // logger('当前队列：', this.adShowWaitingQueue);
            }
        }
    },

    onAdShow(data, eventName) {
        if (!this.isSafeContext()) return;
        // logger('上报数据为：', data);
        report({
            [eventName]: 'show'
        }, data);
    },

    isSafeContext() {
        return window.BiliCm && window.BiliCm.Base;
    }
};

export default Adv2;